import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

import {RootScopeService} from '../shared-service/root-scope.service';
import { RootScopeDeclare } from '../rootscope-declare';

@Component({
  selector: 'app-recaptcha',
  templateUrl: './recaptcha.component.html',
  styleUrls: ['./recaptcha.component.css']
})
export class RecaptchaComponent implements OnInit {

  @Output() captchaStatus = new EventEmitter<string>();

  rootScopeData: RootScopeDeclare;

  protected aFormGroup: FormGroup;
  public readonly siteKey = '6LfyB00UAAAAAIgsVBXrijubyyZk614qs_rCt3A7';
  isGoogleRecaptchaBlocked: boolean;

  constructor(private formBuilder: FormBuilder, private rootScopeService: RootScopeService) {
    this.getRootScopeData();
  }

  ngOnInit() {
    this.aFormGroup = this.formBuilder.group({
      recaptcha: ['', Validators.required]
    });

    window.setTimeout(() => this.checkGoogleRecaptchaAvailability(), 5000);
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  handleLoad(): void {
    this.isGoogleRecaptchaBlocked = false;
  }

  handleSuccess(captchaResponse: string): void {
    this.captchaStatus.emit('success');
  }

  handleExpire(captchaResponse: string): void {
    this.captchaStatus.emit('expired');
  }

  handleError(captchaResponse: string): void {
    this.captchaStatus.emit('error');
  }

  handleReset(captchaResponse: string): void {
    // reset captcha
  }

  handleOnloadCallback(captchaResponse: string): void {
    console.log.bind(this, "recaptcha loaded");
  }

  checkGoogleRecaptchaAvailability(): void {
      if (this.isGoogleRecaptchaBlocked !== false) {
        this.isGoogleRecaptchaBlocked = true;
      }

  }

  onChinaCaptchaStatusChange(status: string): void {
    this.captchaStatus.emit(status);
  }


}
